import axios from 'axios'
let host = 'api.5yoho.cn', pointCnt = 0;
if (window.location.host.match(/\./ig)) pointCnt = window.location.host.match(/\./ig).length;
switch (pointCnt) {
  case 0://本地
    host = 'local.api.5yoho.cn';
    break;
  case 1://只匹配到 5yoho.cn
    host = 'api.' + window.location.host
    break;
  case 2:
    host = (window.location.host.toLowerCase().indexOf('sandbox') >= 0 ? 'sandboxapi.' : 'api.') + window.location.host.split('.').slice(1).join('.');
    break;
  case 3:
    if (/(192|127)/.test(window.location.host.split('.').shift())) {
      host = 'local.api.5yoho.cn';
    } else {
      host = 'api.5yoho.cn'
    }
    break;
  default:
    host = 'api.5yoho.cn';
    break;
}
let protocol = 'https:' == document.location.protocol ? 'https' : 'http';
let axiosWrap = axios.create({
  method: "post",
  baseURL: protocol + "://" + host + "/h5.php?t=" + new Date().valueOf(),
  // headers: { 'X-Requested-With': 'XMLHttpRequest' }
});
export default axiosWrap